var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('headers'),_c('right'),_c('scrollpage'),_c('div',{staticClass:"w box_sizing width_box my_wrap"},[_c('div',{staticClass:"left_position"},[_c('left')],1),_c('div',{staticClass:"banner_detail box_sizing",domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('footers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }